import { useRef, useState, useEffect, useMemo } from 'react';

import styles from './Stepper.module.css';

const DashedLine = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);

  const DASH_WIDTH = 4;
  const GAP_WIDTH = 4;
  const PATTERN_SIZE = DASH_WIDTH + GAP_WIDTH;

  useEffect(() => {
    if (!containerRef.current) return;

    // Create a ResizeObserver to watch the container’s width.
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });

    resizeObserver.observe(containerRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  const segmentCount = useMemo(() => Math.floor(containerWidth / PATTERN_SIZE), [containerWidth]);

  return (
    <div className={styles.line} ref={containerRef}>
      {Array.from({ length: segmentCount }).map((_, idx) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          className={styles.spaceItem}
          key={idx}
          style={{
            width: `${DASH_WIDTH}px`,
            marginRight: idx < segmentCount - 1 ? `${GAP_WIDTH}px` : 0,
          }}
        />
      ))}
    </div>
  );
};

export const StepSpacer = () => {
  return (
    <div className={styles.spacerContainer}>
      <div className={styles.largeBlock}></div>
      <DashedLine />
      <div className={styles.largeBlock}></div>
    </div>
  );
};
